import React from "react";
import { observer } from "mobx-react";
import { EditionDocumentTypeCreateStore } from "../../store";
import { EditionDocumentTypeCreateForm } from "./EditionDocumentTypeCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type EditionDocumentTypeCreateProps = {
  editionDocumentTypeCreateStore: EditionDocumentTypeCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const EditionDocumentTypeCreate: React.FC<EditionDocumentTypeCreateProps> =
  observer(
    ({
      editionDocumentTypeCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={editionDocumentTypeCreateStore.isSaving} />
          <EditionDocumentTypeCreateForm
            editionDocumentTypeCreateStore={editionDocumentTypeCreateStore}
            nameError={editionDocumentTypeCreateStore.errors.name?.message}
            onNameChange={(value: string) => {
              editionDocumentTypeCreateStore.setNameValue(value);
            }}
            name={editionDocumentTypeCreateStore.entityValues.name}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={editionDocumentTypeCreateStore.isProcessing}
            onSave={() =>
              editionDocumentTypeCreateStore.saveNewEditionDocumentType()
            }
            onCancel={() =>
              editionDocumentTypeCreateStore.cancelNewEditionDocumentType()
            }
          />
          <ErrorDialog
            open={editionDocumentTypeCreateStore.errorDialogOpened}
            title={editionDocumentTypeCreateStore.errorTitle}
            description={editionDocumentTypeCreateStore.errorDescription}
            onClose={() => editionDocumentTypeCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
